import { Alert, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

/**
 * Props for UpgradePrompt component
 */
interface UpgradePromptProps {
  /** The main message to display */
  message: string;
  /** Optional feature name for context */
  feature?: string;
  /** Custom button text (defaults to "Upgrade to Pro") */
  buttonText?: string;
  /** Custom link destination (defaults to "/billing") */
  linkTo?: string;
  /** Additional styles */
  sx?: object;
}

/**
 * UpgradePrompt component
 * Displays a contextual prompt encouraging users to upgrade their plan
 * Used throughout the app when users encounter plan limitations
 */
export function UpgradePrompt({
  message,
  feature,
  buttonText = 'Upgrade to Pro',
  linkTo = '/billing',
  sx = {},
}: UpgradePromptProps) {
  return (
    <Alert
      severity="info"
      icon={<RocketLaunchIcon />}
      sx={{
        mt: 2,
        '& .MuiAlert-message': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          flexWrap: 'wrap',
          gap: 1,
        },
        ...sx,
      }}
      action={
        <Button
          component={Link}
          to={linkTo}
          size="small"
          color="inherit"
          variant="outlined"
          sx={{
            whiteSpace: 'nowrap',
            borderColor: 'currentColor',
            '&:hover': {
              borderColor: 'currentColor',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          {buttonText}
        </Button>
      }
    >
      <Box component="span">
        {message}
        {feature && (
          <Box component="span" sx={{ fontWeight: 600 }}>
            {' '}
            {feature}
          </Box>
        )}
      </Box>
    </Alert>
  );
}

export default UpgradePrompt;
